module.exports = __webpack_public_path__ + "static/media/icon@2x.1a1f60e4.png";